import { HideField } from 'components/InputsMex/inputs';
import { usePantallaPago } from 'contexts/FormPagoContext';
import useQueryParams from 'hooks/useQueryParams';
import React from 'react';
import { preventDefault } from 'utils/funciones';
import DetalleValores from './DetalleValores';
import FormTarjeta from './FormTarjeta';

const FormPagoOnlyTarjeta = () => {
  const statePantalla = usePantallaPago();
  const { codProducto } = useQueryParams();
  return (
    <form className="row justify-content-center justify-content-lg-around" onSubmit={preventDefault}>
      <div className="col-12 col-lg-6 order-1 order-lg-0">
        <div className="row m-0 m-md-4 m-xl-5">
          <HideField name="medioPago" />
          <HideField name="subMedio" />
          <FormTarjeta />
        </div>
      </div>
      <DetalleValores datosTarifacion={statePantalla.datosTarifacion} codProducto={codProducto} />
    </form>
  );
};

export default FormPagoOnlyTarjeta;
